var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import StyledIcon from './StyledIcon';

var AddIcon = function AddIcon(props) {
  return React.createElement(
    StyledIcon,
    _extends({}, props, {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 20 20'
    }),
    React.createElement('path', { d: 'M16.8571429,8.85714286 L11.1428571,8.85714286 L11.1428571,3.14285714 C11.1428571,2.512 10.632,2 10,2 C9.368,2 8.85714286,2.512 8.85714286,3.14285714 L8.85714286,8.85714286 L3.14285714,8.85714286 C2.51085714,8.85714286 2,9.36914286 2,10 C2,10.6308571 2.51085714,11.1428571 3.14285714,11.1428571 L8.85714286,11.1428571 L8.85714286,16.8571429 C8.85714286,17.488 9.368,18 10,18 C10.632,18 11.1428571,17.488 11.1428571,16.8571429 L11.1428571,11.1428571 L16.8571429,11.1428571 C17.4891429,11.1428571 18,10.6308571 18,10 C18,9.36914286 17.4891429,8.85714286 16.8571429,8.85714286' })
  );
};
export default AddIcon;